import { Search, CircleCheck } from 'lucide-react';

import PaymentWrapper from '@/app/payment/PaymentWrapper';
import PaymentForm from '@/app/payment/PaymentForm';
import { CART_STATUS } from '@/app/cart/enums';

import {
  Empty,
  EmptyIcon,
  EmptyTitle,
  EmptyDescription
} from '@/components/ui/empty';

import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';

import { useCart } from '@/data/cart';

const Payment = ({ cartId }) => {
  const cart = useCart(cartId);

  if (cart.data.status === CART_STATUS.COMPLETED) {
    return (
      <Empty>
        <EmptyIcon>
          <CircleCheck />
        </EmptyIcon>
        <EmptyTitle>Cart Processed</EmptyTitle>
        <EmptyDescription>Create a new cart to continue</EmptyDescription>
      </Empty>
    );
  }

  if (cart.data.items.length === 0) {
    return (
      <Empty>
        <EmptyIcon>
          <Search />
        </EmptyIcon>
        <EmptyTitle>No Items in cart</EmptyTitle>
        <EmptyDescription>Go find your Pro!</EmptyDescription>
      </Empty>
    );
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Payment</CardTitle>
      </CardHeader>
      <CardContent>
        <PaymentWrapper cartId={cartId} key={cart.data.total}>
          <PaymentForm cartId={cartId} />
        </PaymentWrapper>
      </CardContent>
    </Card>
  );
};

export default Payment;
